import type { RouteConfig } from 'vue-router';

/**
 * 钱包路由
 */
export default [
  /**
   * 钱包主页
   */
  {
    path: '/wallet',
    meta: {
      title: '我的钱包',
      excludeTracking: true,
      customNavBar: true,
    },
    component: () => import('@/views/wallet/index.vue'),
  },
  /**
   * 账单
   */
  {
    path: '/wallet/bill',
    meta: {
      title: '账单',
    },
    component: () => import('@/views/wallet/bill.vue'),
  },
  /**
   * 提现页面
   */
  {
    path: '/wallet/withdraw',
    meta: {
      title: '提现',
      customNavBar: true,
      excludeTracking: true,
    },
    component: () => import('@/views/wallet/withdraw/index.vue'),
  },
  /**
   * 提现结果页
   */
  {
    path: '/wallet/withdraw/result',
    meta: {
      title: '提现结果',
    },
    component: () => import('@/views/wallet/withdraw/result.vue'),
  },
] as RouteConfig[];
